import React, { useContext, useRef, useState, useEffect } from "react";
import "../../css_files/Enquiry/EnquiryTable.css";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api";
import { triggerscroll } from "../Homepage/Homepage";

function EnquiryTable({
  serviceEnquiries,
  setShowServiceEnquiry,
  setTriggerEnquiry,
  refresh,
  setrefresh,
  setEnquiryId,
  setshowenquiryInfo,
  setenquiryinfodata,
  loading,
  readPermission,
  writePermission,
  updatePermission,
  deletePermission,
}) {
  const nav = useNavigate();
  const tableRef = useRef();
  const [deleteLoader, setDeleteLoader] = useState([]);

  useEffect(() => {
    setDeleteLoader(
      Array.from({ length: serviceEnquiries?.length }, () => false)
    );
  }, [serviceEnquiries?.length]);

  return (
    <section className="enquiry-table">
      <blockquote className="navigate-left-right-bottom-table">
        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: -tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>

        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-right"></i>
        </button>
      </blockquote>
      <section className="table" ref={tableRef}>
        <section>
          <div>
            <aside
              style={{
                gridTemplateColumns: "repeat(12, 1fr)",
              }}
            >
              <blockquote>Series ID</blockquote>
              <blockquote>Company / Organization Name</blockquote>
              <blockquote>Contact Person Name</blockquote>

              <blockquote style={{ gridColumn: "span 2", width: "20rem" }}>
                Address
              </blockquote>

              <blockquote>Boiler Head - Series</blockquote>

              <blockquote> Date of Enquiry</blockquote>
              <blockquote>Priority</blockquote>
              <blockquote>Ticket Created</blockquote>
              <blockquote style={{ gridColumn: "span 3" }}>Actions</blockquote>
            </aside>
          </div>
          <div>
            {readPermission() ? (
              loading ? (
                <aside
                  style={{
                    gridTemplateColumns: "repeat(12, 1fr)",
                  }}
                >
                  <blockquote style={{ gridColumn: "span 12" }}>
                    <center>
                      <i
                        class="fa-solid fa-snowflake fa-spin"
                        style={{ fontSize: "2.5rem" }}
                      ></i>
                    </center>
                  </blockquote>
                </aside>
              ) : serviceEnquiries.length > 0 ? (
                serviceEnquiries.map((enquiry, index) => (
                  <aside
                    style={{
                      gridTemplateColumns: "repeat(12, 1fr)",
                    }}
                  >
                    <blockquote>{enquiry?.seriesID}</blockquote>
                    <blockquote>{enquiry?.customer?.orgName}</blockquote>
                    <blockquote>{enquiry?.contactCentre?.name}</blockquote>

                    <blockquote
                      style={{ gridColumn: "span 2", width: "20rem" }}
                    >
                      {`${enquiry?.shipToAddress?.addressType}: ${
                        enquiry?.shipToAddress?.officeName ??
                        enquiry?.shipToAddress?.factoryName
                      }, ${enquiry?.shipToAddress?.address1}, ${
                        enquiry?.shipToAddress?.address2
                      }, ${
                        enquiry?.shipToAddress?.cityObj?.name ||
                        enquiry?.shipToAddress?.cityName
                      }, ${
                        enquiry?.shipToAddress?.stateObj?.name ||
                        enquiry?.shipToAddress?.stateName
                      }, ${enquiry?.shipToAddress?.country}, ${
                        enquiry?.shipToAddress?.pincode
                      }`}
                    </blockquote>

                    <blockquote>
                      {enquiry?.customerBoiler?.boiler?.head}{" "}
                      {enquiry?.customerBoiler?.boilerSeriess?.seriesCode}
                    </blockquote>

                    <blockquote>
                      {new Date(enquiry?.dateOfEnquiry).toLocaleDateString()}
                    </blockquote>
                    <blockquote>{enquiry?.priority}</blockquote>
                    <blockquote>
                      {enquiry?.isTicketCreated ? "Yes" : "No"}
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        if (enquiry?.isTicketCreated) {
                          setenquiryinfodata(enquiry);
                          setshowenquiryInfo(true);
                        } else {
                          setEnquiryId(enquiry?.seriesID);
                          nav("/dashboard/checkin/steps/step1");
                        }
                      }}
                    >
                      <i className="fa-solid fa-eye" title="View"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setShowServiceEnquiry(true);
                        setTriggerEnquiry({
                          update: true,
                          seriesId: enquiry.seriesID,
                        });
                      }}
                      style={{
                        pointerEvents: updatePermission() && "none",
                      }}
                    >
                      <i
                        className="fa-solid fa-pen-to-square"
                        title="Edit"
                        style={{
                          color: updatePermission() && "gray",
                        }}
                      ></i>
                    </blockquote>
                    <blockquote
                      style={{
                        pointerEvents: deletePermission() && "none",
                      }}
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?",
                          text: "You won't be able to revert this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, delete it!",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setDeleteLoader((prev) =>
                              prev.map((_, i) => i === index)
                            );
                            axiosInstance
                              .put(
                                `${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry`,
                                {
                                  SeriesID: enquiry?.seriesID,
                                  isDeleted: true,
                                }
                              )
                              .then((res) => {
                                toast.success("Record Deleted Successfully", {
                                  position: "bottom-center",
                                  theme: "dark",
                                });
                                setrefresh(!refresh);
                              })
                              .catch(console.log)
                              .finally(() => {
                                setDeleteLoader((prev) =>
                                  prev.map((_) => false)
                                );
                              });
                          }
                        });
                      }}
                    >
                      {deleteLoader[index] ? (
                        <i
                          class="fa-solid fa-hurricane fa-spin"
                          title="Please Wait..."
                        />
                      ) : (
                        <i
                          className="fa-solid fa-trash"
                          title="Delete"
                          style={{
                            color: deletePermission() && "gray",
                          }}
                        ></i>
                      )}
                    </blockquote>
                  </aside>
                ))
              ) : (
                <aside
                  style={{
                    gridTemplateColumns: "repeat(12, 1fr)",
                  }}
                >
                  <blockquote style={{ gridColumn: "span 12" }}>
                    <center>
                      <h3>No Enquiries Created</h3>
                    </center>
                  </blockquote>
                </aside>
              )
            ) : (
              <aside
                style={{
                  gridTemplateColumns: "repeat(12, 1fr)",
                }}
              >
                <blockquote style={{ gridColumn: "span 12" }}>
                  <center>You Do Not Have Read Permission</center>
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
    </section>
  );
}

export default EnquiryTable;
